import { css, type Interpolation, type Theme } from '@emotion/react'
import { ReactNode, memo, useMemo } from 'react'
import IconButton, { type IconButtonProps } from '../../../Buttons/IconButton'
import { palette } from '../../../styles/colors'

const chatActionStyles = css({
    flex: '1 1 auto',
    color: palette.buttonBackground,
    borderRadius: 0,
    letterSpacing: 'normal',
})

interface IChatActionButton extends IconButtonProps {
    testId?: string
    children: ReactNode
    styleOverrides?: Interpolation<Theme>
    disabled?: boolean
    label?: string
    onClick(): void
}

const ChatActionButton = memo((props: IChatActionButton) => {
    const {
        testId,
        children,
        disabled = false,
        label,
        onClick = () => {},
        styleOverrides,
    } = props
    const MemoizedChildren = useMemo(
        () => (
            <>
                {children}
                {typeof label === 'string' && label.length > 0 && (
                    <span>{label}</span>
                )}
            </>
        ),
        [children, label],
    )
    return (
        <IconButton
            data-testid={testId}
            onClick={onClick}
            css={[chatActionStyles, styleOverrides]}
            disabled={disabled}
            zeroVerticalPadding
        >
            {MemoizedChildren}
        </IconButton>
    )
})

export default ChatActionButton
